module.exports = __webpack_public_path__ + "b3370e78ec89b079a09ead1249593417.pdf";